package de.ohhhmhhh.frontend.admin.helper

fun Euro(amount: Int): String {
    val euro = amount / 100
    val cents = amount % 100
    val centsString = if (cents < 10) "0$cents" else "$cents"
    return "$euro,$centsString€"
}